export const LS_KEY_USER_EMAIL = "window_app_user_email";
export const LS_KEY_USER_CLIENT = "window_app_user_client";
